export const container = ({ width, slides, translate, transitionDuration, theme: { colors } }) => ({
    width: width * slides.length,
    display: 'flex',
    transform: `translateX(${translate}px)`,
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s`,
    willChange: 'transform',
    color: colors.white,
});

export const extendButton = {
    button: () => ({
        marginLeft: 'auto',
        display: 'block',
        position: 'relative',
        right: '2.5rem',
    }),
};

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
    }),
};
